import { createSlice } from '@reduxjs/toolkit';

// Define a type for the slice state
interface IRackAuditState {
  data: Array<IRackAudit> | null;
  pageSize: number;
  pageNumber: number;
  totalCount: number;
  showLoading: ILoading;
  rackAuditDetails: IRackAudit | null;
}

// Define the initial state using that type
const initialState: IRackAuditState = {
  data: null,
  pageSize: 0,
  pageNumber: 0,
  totalCount: 0,
  showLoading: {
    sourceAction: "",
    state: false,
  },
  rackAuditDetails: null,
};

export const rackAuditSlice = createSlice({
  name: "rackAudit",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.showLoading = {
        sourceAction: action.payload.sourceAction,
        state: true,
      };
    },
    resetLoading: (state, action) => {
      state.showLoading = {
        sourceAction: "",
        state: false,
      };
    },
    replaceItems: (state, action) => {
      const { data, pageSize, pageNumber, totalCount } = action.payload;

      state.data = data;
      state.pageSize = pageSize;
      state.pageNumber = pageNumber;
      state.totalCount = totalCount;
    },
    setrackAuditDetails: (state, action) => {
      state.rackAuditDetails = action.payload.data;
    },
  },
});

export const rackAuditActions = rackAuditSlice.actions;

export default rackAuditSlice.reducer;